const contentArticleType = [
    { key: "STRATEGIES_AND_FUNDING",        value: "Strategies & Funding" },
    { key: "MARKET_INSIGHTS",               value: "Market Insights" },
    { key: "INDUSTRY_INSIGHTS",             value: "Industry Insights" },
    { key: "GO_TO_MARKET",                  value: "Go To Market" },
    { key: "SALES_EFFECTIVENESS",           value: "Sales Effectiveness" },
    { key: "SUPPORT_SYSTEMS_AND_FUNCTIONS", value: "Support Systems & Functions" },
    { key: "GLOBAL_SOURCING",               value: "Global Sourcing" },
    // Legacy — remove after content migration
    { key: "MARKET_INSIGHT",    value: "Market Insight" },
    { key: "INDUSTRY_INSIGHT",  value: "Industry Insight" },
    { key: "PRODUCT_INSIGHT",   value: "Product Insight" },
    { key: "SERVICE_INSIGHT",   value: "Service Insight" },
    { key: "COMPANY_INSIGHT",   value: "Company Insight" },
    { key: "TRAINING_SESSION",  value: "Training Session" },
];

export { contentArticleType };